import { render, staticRenderFns } from "./ValidateAccount.vue?vue&type=template&id=35835ee4&scoped=true&"
import script from "./ValidateAccount.vue?vue&type=script&lang=js&"
export * from "./ValidateAccount.vue?vue&type=script&lang=js&"
import style0 from "./ValidateAccount.vue?vue&type=style&index=0&id=35835ee4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35835ee4",
  null
  
)

export default component.exports